import NextImage from 'next/image';
import { StructuredText, Image } from 'react-datocms';
import type { FeaturedImageBandFragment } from '@/utils/dato/generated';
import { customNodeRules, renderBlock } from '@/components/structuredText';

const FeaturedImageBand = ({ featuredImage, content }: FeaturedImageBandFragment) => (
  <div className="mb-9 -mt-7 md:-mt-9">
    <div className="max-w-[250px] mx-auto">
      {featuredImage ? (
        featuredImage.responsiveImage ? (
          <Image data={featuredImage.responsiveImage} className="mb-9 md:mb-13" />
        ) : (
          <div
            style={{ position: 'relative', aspectRatio: '1/1', height: 'auto', width: '100%' }}
            className="mb-9 md:mb-13"
          >
            <NextImage
              alt={featuredImage.title || 'Featured image'}
              style={{ objectFit: 'contain' }}
              src={featuredImage.url}
              unoptimized
              fill
            />
          </div>
        )
      ) : null}
    </div>
    <div className="container px-5 [&>.row]:max-w-[250px] [&>.row]:md:max-w-[992px] [&>.row]:mx-auto! text-center">
      <StructuredText customNodeRules={customNodeRules} renderBlock={renderBlock} data={content} />
    </div>
  </div>
);

export default FeaturedImageBand;
